import api from './api'

const resetUserPassword = (token: string, data: { password: string; passwordCompare: string }): Promise<unknown> =>
    api<unknown>({ method: 'PUT', path: `/auth/password/reset/${token}`, body: data })

export default resetUserPassword
